export class User {
    loggedin: boolean = false;
    email: string = '';
    name: string = '';
    image: string = '';
    token: string = '';

    public static Info: User = new User();

    public static Set(email: string, name: string, image: string, token: string): void {
        const u = new User();
        u.email = email;
        u.name = name;
        u.image = image;
        u.token = token;
        User.Info = u;
    }
}
